import React, { useEffect, useState } from "react";
import { CheckIcon, GlobeIcon, FlameIcon, LockIcon } from "lucide-react";
import { CTAButton } from "./CTAButton";
import { Countdown } from "./Countdown";
import { images } from "../data/content";
const TOTAL_SPOTS = 100;
const features = ["No recurring subscription fees.", "Instant digital delivery.", "Access to the edition you purchase.", "Printable and reusable professional resources.", "Seven-day money-back guarantee."];
export function Offer() {
  const [spotsLeft, setSpotsLeft] = useState(7);
  useEffect(() => {
    const id = window.setInterval(() => {
      setSpotsLeft(s => s > 3 ? s - 1 : s);
    }, 45000);
    return () => window.clearInterval(id);
  }, []);
  const filled = (TOTAL_SPOTS - spotsLeft) / TOTAL_SPOTS * 100;
  return <section id="offer" className="w-full bg-navy px-4 py-16 sm:py-20" data-id="element-197" data-mp="2fbeo6dta2z94">
      <div className="mx-auto max-w-2xl" data-id="element-198" data-mp="2ad3crync4gos">
        <div className="text-center" data-id="element-199" data-mp="2acbicr5h4p03">
          <p className="text-xs font-bold uppercase tracking-[0.14em] text-gold sm:text-sm" data-id="element-200" data-mp="2affucap6kp1b">
            What if you could organize your references in one place?
          </p>
          <p className="mt-4 font-serif text-[26px] font-bold leading-snug text-white sm:text-3xl" data-id="element-201" data-mp="uhqvqq1xn63i">
            One purchase. Six practical volumes. Five specialized tools.{" "}
            <span className="text-gold" data-id="element-202" data-mp="13iynep9y18om">One structured nutrition care reference system.</span>
          </p>
        </div>

        <div className="mt-10 overflow-hidden rounded-3xl bg-white ring-4 ring-gold" data-id="element-203" data-mp="6vkc16j5c1xg">
          <div className="bg-gold px-4 py-3 text-center" data-id="element-204" data-mp="btlrzil9zl4p">
            <p className="text-sm font-black uppercase tracking-widest text-navy" data-id="element-205" data-mp="funss3uuc58s">Your special launch offer</p>
          </div>

          <div className="px-5 py-7 sm:px-8" data-id="element-206" data-mp="km5uwv8lobvc">
            <h2 className="text-center font-serif text-2xl font-bold leading-tight text-navy sm:text-3xl" data-id="element-207" data-mp="kmyxrl4fuh87">
              Insulin Resistance Nutrition Blueprint™ Complete Collection
            </h2>

            <img src={images.hero} alt="Complete collection" className="-mx-5 mt-4 w-[calc(100%+2.5rem)] max-w-none sm:mx-auto sm:w-full sm:max-w-md" data-id="element-208" data-mp="3o7uvw2flo6zp" />

            <div className="mt-4 space-y-4" data-id="element-209" data-mp="qfmbvyr5xtvn">
              <div className="rounded-xl bg-cream p-4" data-id="element-210" data-mp="qete3na6mepn">
                <div className="flex items-baseline justify-between gap-3" data-id="element-211" data-mp="1548ty886czqk">
                  <h3 className="text-[16px] font-bold text-navy" data-id="element-212" data-mp="10679biv3oscz">The Six-Volume Collection</h3>
                  <span className="shrink-0 text-[15px] font-bold text-danger line-through" data-id="element-213" data-mp="cgd15elq7rz2">$79</span>
                </div>
                <p className="mt-1 text-[14px] leading-relaxed text-muted" data-id="element-214" data-mp="7j3bpyyc7gb8">
                  Assessment, metabolic health reviews, nutrition planning, complex cases, progress reviews, and long-term care
                  organization.
                </p>
              </div>
              <div className="rounded-xl bg-cream p-4" data-id="element-215" data-mp="1ww6qg1pbgz76">
                <div className="flex items-baseline justify-between gap-3" data-id="element-216" data-mp="1wyszk5ruvmri">
                  <h3 className="text-[16px] font-bold text-navy" data-id="element-217" data-mp="1sul840u0jspl">Five Specialized Professional Tools</h3>
                  <span className="shrink-0 text-[15px] font-bold text-danger line-through" data-id="element-218" data-mp="20dcd2a5pe6vn">$87</span>
                </div>
                <p className="mt-1 text-[14px] leading-relaxed text-muted" data-id="element-219" data-mp="25bdyh1qlqiaa">
                  Assessment Worksheet, Metabolic Health Review Matrix, Nutrition Consultation Planner, Progress Review Tracker,
                  and Long-Term Metabolic Health Checklist.
                </p>
              </div>
            </div>

            <div className="mt-6 text-center" data-id="element-220" data-mp="2o3yjjx027j3j">
              <p className="text-[16px] text-muted" data-id="element-221" data-mp="2o3orm3vgf1v7">
                Total Reference Value: <span className="font-bold text-danger line-through" data-id="element-222" data-mp="29eamj7ywv6lm">$166</span>
              </p>
              <p className="mt-3 text-[15px] font-semibold text-ink" data-id="element-223" data-mp="2eddfvv5j3odr">Get the complete collection today for just:</p>
              <p className="mt-1 font-serif text-[76px] font-black leading-none text-cta sm:text-[96px]" data-id="element-224" data-mp="322g63re8apjv">
                $27<span className="ml-1 align-top font-sans text-2xl font-bold text-navy" data-id="element-225" data-mp="36w0tyqm3y35c">USD</span>
              </p>
              <p className="mt-2 text-sm font-black uppercase tracking-widest text-navy" data-id="element-226" data-mp="1j4bjjojfudmp">One-time payment</p>
            </div>

            <div className="mt-5 flex items-start gap-3 rounded-xl border border-navy/15 bg-white p-3.5" data-id="element-227" data-mp="197ylyfkrvfmo">
              <GlobeIcon className="mt-0.5 h-5 w-5 shrink-0 text-navy" aria-hidden="true" data-id="element-228" data-mp="149ncw72ax95i" />
              <p className="text-[14px] leading-relaxed text-ink" data-id="element-229" data-mp="21wmemw7up7a9">
                <strong data-id="element-230" data-mp="21yyrww2nytgz">Automatic currency conversion:</strong> the price is converted to your local currency automatically at
                checkout.
              </p>
            </div>

            <ul className="mt-6 space-y-2.5" data-id="element-231" data-mp="1s59oc91pap6c">
              {features.map(f => <li key={f} className="flex items-start gap-2.5 text-[15px] text-ink" data-id="element-232" data-mp="1n7gijh4b7x6l">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-233" data-mp="2ko5gv0u1whb8" />
                  {f}
                </li>)}
            </ul>

            <div className="mt-7 rounded-xl bg-danger-soft p-4" data-id="element-234" data-mp="2o62zgl7y5oqi">
              <p className="flex items-center justify-center gap-2 text-center text-[15px] font-bold text-danger" data-id="element-235" data-mp="2s6wmzdhh91iv">
                <FlameIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-236" data-mp="2x5g9bezzgfbr" />
                Only {spotsLeft} spots left at the promotional price!
              </p>
              <div className="mt-3 h-5 w-full overflow-hidden rounded-full bg-danger/15" role="progressbar" aria-valuenow={Math.round(filled)} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-237" data-mp="322zmscouwo2n">
                <div className="scarcity-stripes h-full rounded-full bg-danger transition-[width] duration-300 ease-out" style={{
                width: `${filled}%`
              }} data-id="element-238" data-mp="3kw3is4pjrd0f" />
              </div>
              <p className="mt-2 text-center text-[13px] font-semibold text-danger/90" data-id="element-239" data-mp="3pstyus1cq8lu">{Math.round(filled)}% of promotional spots claimed</p>
            </div>

            <div className="mt-7" data-id="element-240" data-mp="356dxhj1qfm0d">
              <CTAButton label="Yes, I want Insulin Resistance Nutrition Blueprint™" note="$27 USD · One-Time Payment · 7-Day Money-Back Guarantee" data-id="element-241" data-mp="3539irrqn57vg" />
            </div>

            <Countdown data-id="element-242" data-mp="3a4p6jrk7dshj" />

            <p className="mt-6 flex items-center justify-center gap-2 text-center text-[13px] text-muted" data-id="element-243" data-mp="3a4fc9rs4kz61">
              <LockIcon className="h-4 w-4" aria-hidden="true" data-id="element-244" data-mp="3nv2dbqlcz15a" />
              Secure checkout · The price is charged in the currency shown at checkout.
            </p>
          </div>
        </div>

        <p className="mt-8 text-center text-[15px] leading-relaxed text-white/75" data-id="element-245" data-mp="1nuc90hh1gf2">
          For less than the cost of many professional reference materials, you'll have a structured collection of tools you can
          consult whenever you need to organize your insulin resistance nutrition workflow.
        </p>
      </div>
    </section>;
}